<template>
    <div class="card mb-4">
        <div v-on:click="collapseExpand" role="button" class="card-header">
            <div class="float-right">
                <small role="button" v-if="collapsed" class="wiggle"><i class="fa-sharp fa-solid fa-plus"></i></small>
                <small role="button" v-if="!collapsed"><i class="fa-regular fa-minus"></i></small>
            </div>
            <slot name="header"></slot>
        </div>

        <div class="card-body" v-if="slots.preview || !collapsed" :class="noCardPadding ? 'p-0' : ''">
            <slot v-if="collapsed" name="preview"></slot>
            <slot v-if="!collapsed" name="body"></slot>
        </div>

    </div>
</template>
<script setup lang="ts">
import { ref, useSlots } from "vue";

interface Props {
    initiallyExpanded?: boolean;
    noCardPadding?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    initiallyExpanded: false,
    noCardPadding: false,
});
const slots = useSlots();
const collapsed = ref(!props.initiallyExpanded);

function collapseExpand(): void {
    collapsed.value = !collapsed.value;
}
</script>
